'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = routes;
function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main', {
    url: '/',
    template: '<main settings="$resolve.settings"></main>',
    resolve: {
      settings: function settings(Settings) {
        return Settings.lookup();
      }
    }
  });
}


// WEBPACK FOOTER //
// ./client/app/main/main.routes.js